module.exports = __webpack_public_path__ + "static/img/guide-logo.b11938e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/guide-logo.png
// module id = tPAS
// module chunks = 1